import firebase from "firebase/app";
import "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyCycj8mO5QSf3v_Y8lDj6kw6_IqZ_-nBo4",
    authDomain: "fir-react-upload-5cc5a.firebaseapp.com",
    projectId: "fir-react-upload-5cc5a",
    storageBucket: "fir-react-upload-5cc5a.appspot.com",
    messagingSenderId: "692140005410",
    appId: "1:692140005410:web:11c0f429342cb48558d27b",
    measurementId: "G-9JVHY4JLFJ"
  };

firebase.initializeApp(firebaseConfig);

const {storage} = firebase;
export { storage, firebase as default }